import queryString from 'query-string';
import { productEnum } from './product-enum';

export default class productService {
    static Configure() {
        let selectedProductId;

        const productIdInQueryString = queryString.parse(location.search);

        if (productIdInQueryString.productId) {
            selectedProductId = Number.parseInt(productIdInQueryString.productId, 10);
        }
        const initialState = {
            product: {
                id: selectedProductId,
                name: this.getProductNameById(selectedProductId)
            } };
        return initialState;
    }

    static getProductNameById(id) {
        let productName = '';
        if (id) {
            for (const key in productEnum) {
                if (productEnum[key].id === id) {
                    productName = productEnum[key].name;
                    break;
                }
            }
        }
        return productName;
    }
}



// WEBPACK FOOTER //
// ./app/helpers/product-service.js